import { useStore } from '@/app/providers/store';
import type { UserTagKey } from '@/app/types';

export const resolveUserTags = (tags: string[] | undefined): Record<UserTagKey, boolean> => ({
  isExpert: tags?.includes('expert') || false,
});

/**
 * 通过用户标签判断是否有某些功能的入口
 */
export const useUserTag = (): Record<UserTagKey, boolean> => {
  const userInfo = useStore((state) => state.userInfo);
  return resolveUserTags(userInfo?.tags);
};
